import { useMutation } from '@tanstack/react-query';

import download from 'src/utils/download';
import { API } from 'src/reactQuery/Api';
import { getRequest } from 'src/utils/request';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';

const getFallbackFileName = () => `failed_to_import_jobs_${Date.now()}.csv`;

const downloadImportProjectJobsResultFile = async (projectUuid: string) => {
  const { data } = await getRequest(
    API.GET.getImportProjectJobsResultFile(projectUuid),
    { responseType: 'blob' },
  );

  download(data, getFallbackFileName(), 'text/csv');
  return data;
};

export const useDownloadImportProjectJobsResultFile = (projectUuid: string) => {
  const { handleError } = useMessageHandler();

  const { mutate: downloadFailedRows } = useMutation({
    mutationFn: () => downloadImportProjectJobsResultFile(projectUuid),
    onError: handleError,
  });

  return { downloadFailedRows };
};
